import AssessmentPaper from '@/apps/assessment/components/assessment-paper'
import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import BookSelector from '@/apps/assessment/components/book-selector'
import AssessmentTarckMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import {clazzAllowUserTypes, ClazzAssessmentAllowSubjects } from '@/common/allow-list'

import {
  getClazzDefaultBook,
  getClazzList,
  getClsList,
  getDefaultbook,
  getUnitList,
  getUnits
} from '@/apps/assessment/model/api'
import { SUBJECT_TYPE_LIST } from '@/apps/assessment/model/publish'
import { getInitInfo } from '@/apps/index/models/api'
import PaperPending from '@/apps/paper/components/paper-pending'
import { Ranger } from '@/components'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

const proSource = '精品卷库'
const UCENTER = process.env.VUE_APP_UCENTER_DOMAIN || 'https://ucenter.test.17zuoye.net/'

@Component({
  components: { AssessmentPaper, BasicLayout, BookSelector, Ranger, PaperPending, SmallBtnSkeleton }
})
export default class ClazzAssessmentLib extends Mixins(AssessmentTarckMixin) {
  // 试卷列表信息
  private paperList = []
  private page = 1
  private sum = 0
  private perPage = 10
  private loading = true
  // 测评类型
  private examTypeList: any[] = []
  // 默认选中全部
  private examType = ['', '全部']
  // 题目分类
  private subjectTypes = []
  private subjectTypeList = SUBJECT_TYPE_LIST
  private clazzLevelList: any[] = []
  private defaultBook = {}
  private selectedBook = {
    bookName: '',
    bookId: ''
  }
  // 单元信息
  private unitId = ''
  private unitCName = ''
  private unitList = [{ cname: '请选择', unitId: '' }]
  // 教材选择器
  private selectorVisible = false
  // 题目数量
  private start = ''
  private end = ''
  // 默认年级的 clazzAndGruoup ids
  private gids: any[] = []

  // 新增筛选项
  private provinceChoice = [{ code: 0, name: '全部' }]
  private yearChoice = [['', '全部']]
  private province = { code: 0, name: '全部' }
  private year = ['', '全部']
  private keyword = ''
  private usenumStatus = 'down'
  private usenumSelected = false
  private updateStatus = 'down'
  private updateSelected = true
  // 默认展开
  private flag = true
  private optionsLoading = true
  // 获取学科信息
  private get subject() {
    return this.$store.state.subject
  }
  // 用户地区
  private get regions() {
    return this.$store.state.user_info && this.$store.state.user_info.regions
  }
  // 用户获取班级测评学科
  private get clazzSupportSubjects() {
    return this.$store.state.clazzSupportSubjects
  }
  // 用户信息
  private get userInfo() {
    return this.$store.state.user_info
  }
  // 展示状态
  public get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.paperList && this.paperList.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }

  @Watch('subject', { deep: true, immediate: true })
  public onSubjectChange(val) {
    if (val && val.value) {
      this.getInitInfo()
    }
    this.selectedBook = {
      bookName: '',
      bookId: ''
    }
    // 清空搜索关键词
    this.keyword = ''
    this.year = ['', '全部']
    this.getClassList()
  }
  // 配置测评页面允许外界直接跳转进入
  @Watch('userInfo', { deep: true })
  public onUserChanges(val) {
    if (this.userInfo && clazzAllowUserTypes.indexOf(this.userInfo.user_type) > -1) {
      const arr = this.userInfo.subjects.filter((n) => {
        return ClazzAssessmentAllowSubjects.find((item) => item.value == n[0])
      })
      if (arr && arr.length) {
        console.log('pass')
      } else {
        this.$router.replace({ path: '/clazz/nopermission' })
      }
    } else {
      this.$router.replace({ path: '/clazz/nopermission' })
    }
  }
  // mount
  public created() {
    this.page = 1
  }
  // 题目分类勾选
  public onSubjectTypesChange(checkedVals) {
    // 筛选
    this.getPaperList((this.page = 1))
  }
  // 是否选中
  public judgeSelected(itm, temp): boolean {
    return itm[0] === temp[0]
  }
  public onPageChange(page: number): void {
    this.page = page
    this.getPaperList(page)
  }
  public clickExamType(itm): void {
    this.examType = itm
    this.page = 1
    this.getPaperList(this.page)
  }
  // 获取试卷信息
  public async getInitInfo() {
    try {
      this.optionsLoading = true
      const data: any = await getInitInfo({ subject_id: this.subject.value, is_cls: 1 })
      this.examTypeList = [['', '全部'], ...data.data.cp_cls_paper_types]
      this.provinceChoice = [{ code: 0, name: '全部' }, ...data.data.region_choices]
      const yearChoice = data.data.cp_paper_years.map((m) => {
        return [m, m]
      })
      this.yearChoice = [['', '全部'], ...yearChoice]
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  public async getClassList() {
    try {
      const data: any = await getClazzList({ subject: this.subject.nick })
      if (data.success) {
        if (data.clazzList && data.clazzList.length > 0) {
          this.clazzLevelList = data.clazzList.map((n) => {
            n.level = n.clazzLevel
            n.levelName = n.clazzLevelName
            n.clazzs = n.clazzs.map((m) => {
              m.clazzAndGroup = `${m.clazzId}_${m.groupId}`
              return m
            })
            n.clazzAndGroup = n.clazzs.map((m) => {
              return m.clazzAndGroup
            })
            return n
          })

          this.gids = this.clazzLevelList[0].clazzAndGroup
          this.getDefaultbook()
        } else {
          // 如果没有班组信息跳转至主站用户中心
          this.$warning({
            title: '您尚未设置班组信息',
            content: '如需使用班级测评，请先设置班组信息哦',
            maskClosable: false,
            okText: '去设置',
            onOk() {
              window.open(UCENTER + '/teacher/systemclazz/clazzindex.vpage?step=showtip')
            }
          })
        }
      } else {
        this.gids = []
      }
    } catch (e) {}
  }
  // 获取默认教材
  public async getDefaultbook() {
    try {
      if (!(this.gids && this.gids.length > 0)) return
      const data: any = await getClazzDefaultBook({
        subject: this.subject.nick,
        clazzs: this.gids.join(',')
      })
      if (data.success) {
        this.defaultBook = data.clazzBook
        this.selectedBook = {
          bookId: data.clazzBook && data.clazzBook.bookId,
          bookName: data.clazzBook && data.clazzBook.bookName
        }
        this.unitList = [{ cname: '请选择', unitId: '' }, ...data.clazzBook.unitList]
        const defaultUnit: any = this.unitList.find((itm: any) => itm.defaultUnit)
        this.unitId = ''
        this.unitCName = '请选择'
        // 获取试卷列表
        this.page = 1
        this.getPaperList(this.page)
      }
    } catch (e) {}
  }
  public async getUnits() {
    const data: any = await getUnitList({
      bookId: this.selectedBook.bookId || ''
    })
    if (data.success) {
      this.unitList = [{ cname: '请选择', unitId: '' }, ...data.book.unitList]
      const defaultUnit: any = this.unitList.find((itm: any) => itm.defaultUnit)
      this.unitId = ''
      this.unitCName = '请选择'
      this.page = 1
      this.getPaperList(this.page)
    }
  }
  // 选择单元
  public onUnitSelect(value, option) {
    this.unitId = value
    this.page = 1
    this.getPaperList(this.page)
  }
  public showSelector() {
    this.selectorVisible = true
  }
  public onSelectorOK(val) {
    this.selectorVisible = false
    this.selectedBook = val && val.length > 0 ? val[0] : { bookName: '', bookId: '' }
    if (this.selectedBook && this.selectedBook.bookId) {
      this.getUnits()
    } else {
      // 当选择的教材为空时，重置单元
      this.unitList = [{ cname: '请选择', unitId: '' }]
      this.unitId = ''
      this.unitCName = ''
      // 获取试卷列表
      this.page = 1
      this.getPaperList(this.page)
    }
  }
  public onSelectorCancel() {
    this.selectorVisible = false
  }
  public async getPaperList(page) {
    let sort_way = '-updated_at'
    if (this.updateSelected) {
      if (this.updateStatus === 'up') {
        sort_way = 'updated_at'
      } else {
        sort_way = '-updated_at'
      }
    }
    if (this.usenumSelected) {
      if (this.usenumStatus === 'up') {
        sort_way = 'exam_use_num'
      } else {
        sort_way = '-exam_use_num'
      }
    }
    let params: any = {
      page,
      subject_id: this.subject.value,
      main_question_types: this.subjectTypes,
      num_start: Number(this.start),
      num_end: Number(this.end),
      // use_type: this.examType && this.examType.type,
      paper_type: this.examType[0],
      // 新增字段
      year: this.year && this.year.length && this.year[0],
      region_code: this.province && this.province.code,
      name: this.keyword && this.keyword,
      sort_way
    }
    // 所有的 papertype 都可以到单元
    params.book_catalog_id = this.unitId ? String(this.unitId) : String(this.selectedBook.bookId)
    try {
      this.loading = true
      const data: any = await getClsList(params)
      if (data.success) {
        this.paperList = data.data.papers.map((itm) => {
          itm.paper = JSON.parse(JSON.stringify(itm))
          return itm
        })
        this.sum = data.data.total
      } else {
        this.paperList = []
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }
  public onInputBlur() {
    this.getPaperList((this.page = 1))
  }

  public publish(data) {
    this.trackPublish('去发布', proSource)
    setTimeout(() => {
      this.$router.push({
        path: '/clazz/publish',
        query: {
          subject: this.subject.nick,
          subject_id: this.subject.value,
          pid: data.paper.old_paper_id,
          s: 'QUESTION_BANK',
          f: encodeURIComponent(proSource)
        }
      })
    }, 100)
  }
  public preview(data) {
    this.trackPublish('试卷预览', proSource)
    setTimeout(() => {
      this.$router.push({
        path: '/clazz/paper',
        query: {
          _id: data.paper_id,
          subject: this.subject.nick,
          subject_id: this.subject.value,
          s: 'QUESTION_BANK',
          paper: encodeURIComponent(JSON.stringify(data))
        }
      })
    }, 100)
  }
  // 点击展开/收起
  public switchIt(val: boolean) {
    this.flag = !this.flag
  }
  // 地区
  public clickRegion(item) {
    this.province = item
    this.getPaperList((this.page = 1))
  }
  public clickYear(item) {
    this.year = item
    this.getPaperList((this.page = 1))
  }
  // 清空输入内容时自动检索
  public onKeywordChange() {
    if (this.keyword === '') {
      this.getPaperList((this.page = 1))
    }
  }
  // 点击搜索
  public onSearch() {
    this.getPaperList((this.page = 1))
  }
  // sorter ranger
  public onUsenumChange(val) {
    this.usenumStatus = val
    this.getPaperList((this.page = 1))
  }
  public onSelectUsenum() {
    this.usenumSelected = true
    this.updateSelected = false
    this.getPaperList((this.page = 1))
  }
  public onUpdateChange(val) {
    this.updateStatus = val
    this.getPaperList((this.page = 1))
  }
  public onSelectUpdate() {
    this.updateSelected = true
    this.usenumSelected = false
    this.getPaperList((this.page = 1))
  }
  public reload() {
    location.reload()
  }
}
